import { AlertColor } from "@mui/material";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface NotificationState {
    isOpen?: boolean;
    type?: AlertColor
    message?: string;
}

export interface ConfirmDialogState {
    isOpen: boolean;
    title?: {};
    subTitle?: {};
    onConfirm?: () => void;
    item?: any;
}

const initialState = {
    isMenuOpen: false,
    isRightMenuOpen: false,
    newProperty: true,
    notification: {
        type: "error",
        message: "",
        isOpen: false,
    } as NotificationState,

    dialog: {
        isOpen: false
    } as ConfirmDialogState,

    isLoader: false,
};

export const commonReducerSlice = createSlice({
    name: "commonReducer",
    initialState,
    reducers: {
        setIsLeftMenuOpen: (state, action: PayloadAction<boolean>) => {
            return { ...state, isMenuOpen: action.payload };
        },
        setIsRightMenuOpen: (state, action: PayloadAction<boolean>) => {
            return { ...state, isRightMenuOpen: action.payload };
        },
        showNotification: (state, action: PayloadAction<NotificationState>) => {
            return { ...state, notification: action.payload };
        },

        clearNotification: (state) => {
            return { ...state, notification: {} };
        },

        confirmDialogOpen: (state, action: PayloadAction<ConfirmDialogState>) => {
            return { ...state, dialog: action.payload };
        },

        confirmDialogClose: (state) => {
            return { ...state, dialog: { isOpen: false } };
        },
        showLoader: (state, action: PayloadAction<boolean>) => {
            return { ...state, isLoader: action.payload };
        },
    },
});

export const {
    setIsLeftMenuOpen,
    showNotification,
    clearNotification,
    confirmDialogOpen,
    confirmDialogClose,
    showLoader,
    setIsRightMenuOpen,
} = commonReducerSlice.actions;

const commonReducer = commonReducerSlice.reducer;
export default commonReducer;
